import { OneEyeService } from './api'


const krtiWebUrl = process.env.REACT_APP_WEB_BASE_URL;


export const getTransactionList = async () => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/api/Transactions`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}


export const getTransactionListByProjectId = async (req,projectId) => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/api/Transactions/projects/${projectId}`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const getTransactionReportByUserId = async (reportid,id) => {

    try {
        return await OneEyeService.get(`${krtiWebUrl}/api/Report/type/${reportid}/${id}
        `)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}